module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "font-weight": "bold"
    },
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("Spurious Conversations with Ghosts")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#dedication"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#january-2000-eastbourne"
    }
  }, [_vm._v("January 2000, Eastbourne")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#february-2018-hever-castle"
    }
  }, [_vm._v("February 2018, Hever Castle")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch005#march-2022-brighton",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("March 2022, Brighton")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch006#april-2014-beachy-head",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("April 2014, Beachy Head")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#may-2015-leicester-cathedral",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("May 2015, Leicester Cathedral")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#june-2020-hastings-old-town",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("June 2020, Hastings Old Town")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#july-2022-m-40-motorway-oxfordshire",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("July 2022, M 40 Motorway, Oxfordshire")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#august-2018-hever-castle",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("August 2018, Hever Castle")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#september-1996-bodiam-castle",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("September 1996, Bodiam Castle")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#october-2016-battle-abbey",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("October 2016, Battle Abbey")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#november-2002-caldwell-manor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("November 2002, Caldwell Manor")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#december-2018-ightham-mote",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("December 2018, Ightham Mote")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#survival-city-no.-22-england",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2084, Survival City No. 22, England")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#acknowledgement",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgement")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#about-the-author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0